import styled from 'styled-components';

const Label = styled.label`
  color: #585454;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.4px;
`;

/** @component */
export default Label;
